import $ from 'jquery';

export const init = () => {

	$(document)
		.on('submit', '.newsletter-sent', function(e) {
			e.preventDefault();

			if ( $(this).find('input[name="email"]').val() == '' ) {
				alert( 'Zadejte email.' );
			} else {
				var email_element = $(this).find('input[name="email"]');
				var csob_checked = ( $(this).find('input[name="csob"]').prop('checked') === true ? 1 : 0 );

				$.post( skwp.newsletter_api_url, { email: email_element.val(), csob: csob_checked } ).done( function(data) {
					if ( data.status == 'error') {
						data.message = '<span style="color: red;">' + data.message + '</span>';
					} else {
						email_element.val('');
						console.log( 'newsletterSubscription' );
						// DTM
						measure({
							action: "newsletterSubscription"
						});
					}

					$('.newsletter-return').html(data.message).removeClass('u-hide');
				});
			}
		});

};



// WEBPACK FOOTER //
// ./src/js/components/newsletter.js